function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "phone");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-1140.000000, -650.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Incoming_Call_Decline_Icon",
  transform: "translate(1140.000000, 650.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-18",
  x: 0,
  y: 0,
  width: 80,
  height: 80
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8571596,46.1537142 L30.8571596,47.769121 C30.8571596,49.5533993 29.4180094,50.9999345 27.6428404,50.9999345 L21.2143322,50.9998036 C19.439033,50.9999345 17.9998828,49.5533993 18.0001433,47.769121 L18.000013,46.1538451 L30.8571596,46.1537142 Z M63,46.1537797 L63,47.7691865 C63,49.5534648 61.56098,50.9998691 59.7856808,51 L53.3571726,50.9998691 C51.5817432,50.9998691 50.1427232,49.5534648 50.1428534,47.7690556 L50.1427232,46.1537797 L63,46.1537797 Z M40.499974,30 C52.9364459,29.9998691 62.9999479,33.6122799 62.9999479,38.076772 L62.9999479,38.076772 L62.9999479,42.9229923 L50.1426711,42.9229923 L50.1428013,41.3077165 C50.1429316,39.5217364 45.8299091,38.076772 40.499974,38.076772 C35.1700388,38.076772 30.8571466,39.5218673 30.8571466,41.3074547 L30.8571466,41.3074547 L30.8571466,42.9228614 L18,42.9229923 L18,38.076772 C18,33.6122799 28.0635021,29.9998691 40.499974,30 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}))));

var SvgIncomingCallPhoneIcon = function SvgIncomingCallPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncomingCallPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/incoming-call-phone-icon.f184bb72.svg";
export { ForwardRef as ReactComponent };